import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { useApp } from "../../context/AppContext";
import { useLoad, act, Card, H1, abtn, ainput } from "../../components/admin/ui";

const FIELDS = [["store_name", "Nom de la boutique"], ["tagline", "Accroche"], ["hero_title", "Titre d'accueil"], ["hero_subtitle", "Sous-titre d'accueil"], ["banner_text", "Bandeau"],
  ["legal_name", "Nom légal"], ["legal_address", "Adresse"], ["neq", "NEQ"], ["support_email", "Courriel du service client"], ["support_phone", "Téléphone"]];
const PAGES = [["cgv", "Conditions de vente"], ["confidentialite", "Confidentialité"], ["remboursement", "Retours"], ["expedition", "Livraison"]];

function Upload({ label, onUrl, testid }) {
  const pick = async (e) => {
    const fd = new FormData(); fd.append("file", e.target.files[0]);
    const r = await act(() => api.post("/admin/uploads", fd), "Image téléversée");
    if (r) onUrl(r.url);
  };
  return <label className="text-xs block"><span className="label-xs">{label}</span><input data-testid={testid} type="file" accept="image/png,image/jpeg,image/webp" onChange={pick} className="block mt-1" /></label>;
}

export default function SiteSettings() {
  const [s] = useLoad("/store/site");
  const { reloadSite } = useApp();
  const [f, setF] = useState(null);
  useEffect(() => { if (s) setF({ ...s, legal_pages: s.legal_pages || {}, categories: s.categories || [] }); }, [s]);
  if (!f) return <div className="label-xs">Chargement…</div>;
  const save = async () => { if (await act(() => api.put("/admin/site", f), "Boutique mise à jour")) reloadSite(); };
  return (
    <div>
      <H1 sub="Textes, logo, bannière, catégories et pages légales modifiables sans intervention technique.">Apparence & textes</H1>
      <div className="grid lg:grid-cols-2 gap-4">
        <Card title="Identité" testid="site-identity">
          <div className="grid sm:grid-cols-2 gap-3">
            {FIELDS.map(([k, l]) => <label key={k} className="block"><span className="label-xs">{l}</span><input data-testid={`site-${k}`} value={f[k] || ""} onChange={(e) => setF({ ...f, [k]: e.target.value })} className={`${ainput} w-full mt-1`} /></label>)}
            <label className="block sm:col-span-2"><span className="label-xs">Catégories (séparées par des virgules)</span><input data-testid="site-categories" value={f.categories.join(", ")} onChange={(e) => setF({ ...f, categories: e.target.value.split(",").map((x) => x.trim()).filter(Boolean) })} className={`${ainput} w-full mt-1`} /></label>
            <Upload label={`Logo ${f.logo_url ? "(défini)" : ""}`} testid="site-logo-upload" onUrl={(u) => setF({ ...f, logo_url: u })} />
            <Upload label="Image d'accueil" testid="site-hero-upload" onUrl={(u) => setF({ ...f, hero_image: u })} />
          </div>
        </Card>
        <Card title="Pages légales (vide = modèle Québec par défaut)" testid="site-legal">
          {PAGES.map(([k, l]) => <label key={k} className="block mb-3"><span className="label-xs">{l}</span><textarea data-testid={`site-legal-${k}`} rows={3} value={f.legal_pages[k] || ""} onChange={(e) => setF({ ...f, legal_pages: { ...f.legal_pages, [k]: e.target.value } })} className={`${ainput} w-full mt-1`} /></label>)}
        </Card>
      </div>
      <button data-testid="site-save" onClick={save} className={`${abtn} mt-4`}>Enregistrer</button>
    </div>
  );
}
